module.exports = __webpack_public_path__ + "static/media/logo.9afb7e22.png";